export const patientProfileDocumentAction = {
  setIsUploadModalOpen: (state, action) => {
    state.isUploadModalOpen = action.payload;
  },

  setIsDocumentsLoading: (state, action) => {
    state.isLoading = action.payload;
  },

  setIsDocumentTableLoading: (state, action) => {
    state.isDocumentTableLoading = action.payload;
  },

  setIsSendingSuccess: (state, action) => {
    state.isSendingSuccess = action.payload;
  },

  setIsDownloading: (state, action) => {
    state.isDownloading = action.payload;
  },

  setShowPreview: (state, action) => {
    state.showPreview = action.payload;
  },

  setNoShowLetterPreview: (state, action) => {
    state.noShowPreview = action.payload;
  },

  setShowNoShowEmailModal: (state, action) => {
    state.showNoShowEmailModal = action.payload;
  },

  setIsFileLoading: (state, action) => {
    state.isFileLoading = action.payload;
  },

  setIsLetterTemplateMenu: (state, action) => {
    state.isLetterTemplateMenu = action.payload;
  },

  setIsNowShowLetterMenu: (state, action) => {
    state.isNoShowLetterMenu = action.payload;
  },

  setShowDownloadTemplate: (state, action) => {
    state.showDownloadTemplate = action.payload;
  },

  setShowBatteryInformationModal: (state, action) => {
    state.showBatteryInformationModal = action.payload;
  },

  setShowPreviewMode: (state, action) => {
    state.showPreviewMode = action.payload;
  },

  setDownloadingModalText: (state, action) => {
    state.downloadingModalText = action.payload;
  },

  setIsDocumentTableRefresh: (state, action) => {
    state.isDocumentTableRefresh = action.payload;
  },

  setSelectedDocument: (state, action) => {
    state.selectedDocument = action.payload;
  },

  setSelectedTemplate: (state, action) => {
    state.selectedTemplate = action.payload;
  },

  setBatteryInformation: (state, action) => {
    state.batteryInformation = action.payload;
  },

  setGeneratedLetterFilePath: (state, action) => {
    state.generatedLetterFilePath = action.payload;
  },

  setIsSendingLetter: (state, action) => {
    state.isSendingLetter = action.payload;
  },

  setFile: (state, action) => {
    state.file = action.payload;
  },

  setLetterNextSendDate: (state, action) => {
    state.letterNextSendDate = action.payload;
  },

  setLetterNextSendDateModal: (state, action) => {
    state.showLetterNextSendDateModal = action.payload;
  },

  setPendingBatteryLife: (state, action) => {
    state.pendingBatteryLife = action.payload;
  },
};
